const PlatformType = {
    IOS_WEBVIEW: {
        source: "App",
        value: "IOS_WEBVIEW",
        channelName: 'APP',
        rmode: 4
    },
    ANDROID_WEBVIEW: {
        source: "App",
        value: "ANDROID_WEBVIEW",
        channelName: 'APP',
        rmode: 4
    },
    IOS_MSITE: {
        source: "Web",
        value: "IOS_MSITE",
        channelName: 'WAP',
        rmode: 5
    },
    ANDROID_MSITE: {
        source: "Web",
        value: "ANDROID_MSITE",
        channelName: 'WAP',
        rmode: 5
    },
    WEB: {
        source: "Web",
        value: "WEB",
        channelName: 'WEB',
        rmode: 5
    },
    OTHER_MSITE: {
        source: "Web",
        value: "OTHER_MSITE",
        channelName: 'WAP',
        rmode: 5
    }
}
export default PlatformType